let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k9F5O")).then(() => parcelRequire('1a6OS'));